import type { CSSProperties, ReactNode } from 'react'
import { cx } from './utils/cx'

interface ProgressProps {
  label?: ReactNode
  rate?: ReactNode
  pct?: number
  right?: ReactNode
  rightSub?: ReactNode
  done?: boolean
  size?: ReactNode
  files?: ReactNode
  className?: string
  style?: CSSProperties
}

export function Progress({
  label,
  rate,
  pct = 0,
  right,
  rightSub,
  done,
  size,
  files,
  className,
  style
}: ProgressProps) {
  const hasQuota = size != null || files != null
  const defaultRight = String(Math.round(pct * 100)).padStart(3, '0') + '%'
  return (
    <div className={className ? `st-progress ${className}` : 'st-progress'} style={style}>
      <div className="top">
        <div>
          <b>{label}</b>
          {rate && <span className="rate">{rate}</span>}
        </div>
        <div className="right">
          <div>{right ?? defaultRight}</div>
          {rightSub && <div style={{ opacity: 0.7 }}>{rightSub}</div>}
        </div>
      </div>
      <div className="st-bar">
        <div className={cx('st-bar-fill', done && 'done')} style={{ width: pct * 100 + '%' }} />
      </div>
      {hasQuota && (
        <div className="st-progress-quota">
          <span>{size}</span>
          <span>{files}</span>
        </div>
      )}
    </div>
  )
}
